import { faArrowRotateRight } from "@fortawesome/pro-solid-svg-icons";
import { resumeSubscription } from "~/api/billing/requests";
import { useTranslation } from "react-i18next";
import { DialogModal } from "~/spocketUI/components/DialogModal";
import { useStore } from "~/hooks/useStore";
import handleErrors from "~/spocketUI/helpers/handleErrors";

type Props = {
  isShowing: boolean;
  hide: () => void;
};

export const ResumeModal = ({ isShowing, hide }: Props) => {
  const { t } = useTranslation();
  const { refreshStore } = useStore();

  const handleResume = async () => {
    const toastMessages = {
      loading: t("settings.loading_unpause"),
      success: t("settings.unpause_success"),
      error: t("settings.unpause_error"),
    };

    const { errors } = await handleErrors(
      () => resumeSubscription(),
      toastMessages
    );

    if (!errors) {
      setTimeout(() => {
        refreshStore();
        hide();
      }, 200);
    }
  };

  return (
    <DialogModal
      title={t("settings.resume_modal_title")}
      description={t("settings.resume_modal_desc")}
      buttonText={t("settings.unpause")}
      buttonColor="primary"
      buttonCancelText={t("settings.go_back")}
      handleAction={handleResume}
      isShowing={isShowing}
      hide={hide}
      icon={faArrowRotateRight}
    />
  );
};
